import Swiper from 'swiper';
import 'swiper/css';

const swiper = new Swiper('[data-box="features"]', {
  direction: 'horizontal',
  slidesPerView: 1.11708,
  loop: false,
  spaceBetween: 16,
});
